import Layout from "../../Frames/Layout"

export default function Form(){
    
    return <Layout title='Éditer la formation' tab='courses' menu='admin' back={true}>
        <p>Page en cours de construction</p>
    </Layout>
}